import React from 'react';
import styled from 'styled-components';
import CancelBordered from 'icons/cancel-bordered';

const CancelIcon = styled(CancelBordered).attrs(({ theme }) => ({
  style: {
    primaryColor: theme.colors.selectableLightBg,
  },
}))`
  cursor: pointer;
`;

const ListItemContainer = styled.div`
  flex: 1;
  display: flex;
  margin-bottom: ${({ theme: { grid } }) => grid.units(0.5)};
  justify-content: space-between;
  align-items: left;
  font-size: ${({ theme }) => theme.fontSizes.p};
`;

interface ListItemProps {
  label?: React.ReactNode;
  item: string;
  onDelete: (item: string) => void;
}

export const ListItem = ({ label, item, onDelete }: ListItemProps): React.JSX.Element => (
  <ListItemContainer>
    <span>{label || item}</span>
    <CancelIcon onClick={() => onDelete(item)} type="button" role="button" />
  </ListItemContainer>
);

export default ListItem;
